<script setup>

    import { computed, ref, watch } from 'vue'
    import { storeToRefs } from 'pinia'

    import { useCaregiverSingleStore } from '@/Stores'

    import { SERVICE_TYPES_OPTIONS } from '@/Helpers'

    import InputLabel from '@/Components/Forms/InputLabel.vue'
    import MultiSelect from 'primevue/multiselect'
    import Skeleton from 'primevue/skeleton'

    import { getModifiedProperties } from '@/Helpers'

    const emit = defineEmits(['caregiver:update', 'caregiver:cancel-update'])

    const caregiverSingleStore = useCaregiverSingleStore()
    const { caregiver, loading } = storeToRefs(caregiverSingleStore)

    const localCaregiverBasicInfo = ref({
        service_types: [],
    })

    const hasCaregiverData = computed(() => {
        const hasData = caregiver.value && caregiver.value.id
        return hasData
    })



    const caregiverBasicInfoPropsChange = ref(false)

    watch(() => caregiver.value, (value) => {
        localCaregiverBasicInfo.value = {
            service_types: value.service_types ?? [],
        }

        if (localCaregiverBasicInfo.value.service_types && localCaregiverBasicInfo.value.service_types.length > 0) {
            caregiverBasicInfoPropsChange.value = true
        }
    }, { deep: true, immediate: true })

    function extractCaregiverBasicInfo(proxyCaregiverBasicInfo) {
        return {
            ...proxyCaregiverBasicInfo,
        };
    }

    watch(localCaregiverBasicInfo, (newValue, oldValue) => {
        if (oldValue === undefined) {
            caregiverBasicInfoPropsChange.value = false;
            return;
        }

        if (caregiverBasicInfoPropsChange.value == false) {
            const diff = getModifiedProperties(
                JSON.stringify(extractCaregiverBasicInfo(newValue)),
                JSON.stringify({
                    service_types: caregiver.value.service_types ?? [],
                }),
                [
                    'service_types',
                ]
            )
            handleChange(diff)
            return;
        }
        caregiverBasicInfoPropsChange.value = false
    }, { immediate: true, deep: true })

    const handleChange = (data) => {
        if (Object.keys(data).length > 0) {
            emit('caregiver:update', data);
        } else {
            emit('caregiver:cancel-update', caregiver.value.id);
        }
    }

</script>

<template>

    <div
        id="caregiver_basic_info"
        class="p-6 pb-8"
    >
        <div class="grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12 gap-y-2 gap-x-6">

            <div class="col-span-full">
                <span class="font-bold text-sm text-lifeworx-blue-800 pb-1 inline-block">Service</span>
            </div>

            <div class="sm:col-span-3">
                <InputLabel
                    for="caregiver-basicinfo-servicetypes"
                    value="Service Types"
                    class="text-xs text-stone-400"
                >
                    <Skeleton
                        v-if="!hasCaregiverData && loading"
                        height="34px"
                        class="border bg-lifeworx-blue-800/10 border-lifeworx-blue-800/20"
                    />
                    <MultiSelect
                        v-else
                        id="caregiver-basicinfo-servicetypes"
                        v-model="localCaregiverBasicInfo.service_types"
                        :options="SERVICE_TYPES_OPTIONS"
                        optionLabel="name"
                        optionValue="id"
                        :maxSelectedLabels="3"
                        class="w-full"
                        display="chip"
                        :pt="{
                            root: { class: 'text-xs h-[34px]' },
                            overlay: { class: 'text-sm !z-modal' },
                            header: { class: 'hidden'}
                        }"
                    />
                </InputLabel>
            </div>

        </div>
    </div>

</template>
